<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Relatório de Orçamentos</h1>
    <span *ngIf="carregado" class="badge bg-secondary">Total: {{ orcamentos.length }}</span>
  </div>
  <hr />

  <!-- Filtros -->
  <div class="row g-2 align-items-end mb-3 no-print">
    
    <div class="col-md-3">
      <label class="form-label">Data Inicial <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataInicialInvalida"
             [(ngModel)]="dataInicial" />
      <div class="invalid-feedback" *ngIf="dataInicialInvalida">
        Informe a data inicial.
      </div>
    </div>
    <div class="col-md-3">
      <label class="form-label">Data Final <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataFinalInvalida"
             [(ngModel)]="dataFinal" />
      <div class="invalid-feedback" *ngIf="dataFinalInvalida">
        Informe a data final.
      </div>
    </div>
    
    
    <div class="col-md-3">
      <label class="form-label">Status do Orçamento</label>
      <select class="form-select" [(ngModel)]="statusOrcamento">
        <option value="">Todos</option>
        <option value="ABERTO">Aberto</option>
        <option value="CONCLUIDO">Concluído</option>
        <option value="CANCELADO">Cancelado</option>
      </select>
    </div>

    <div class="col-md-3 d-flex gap-2">
      <button class="btn btn-primary w-100" (click)="buscar()" [disabled]="carregando">
        <span *ngIf="carregando" class="spinner-border spinner-border-sm me-1"></span>
        Buscar
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="limpar()" [disabled]="carregando">
        Limpar
      </button>
    </div>
  </div>

  <div class="alert alert-warning no-print mb-3"
       *ngIf="tentouBuscar && (!dataInicial || !dataFinal)">
    Informe a data inicial e a data final para gerar o relatório.
  </div>

  <div *ngIf="carregando" class="alert alert-info no-print" role="alert">
    Carregando relatório...
  </div>

  <!-- Resultados -->
  <div *ngIf="carregado">

    <div class="d-flex justify-content-end mb-2 no-print">
      <button class="btn btn-outline-dark btn-sm" (click)="imprimir()">Imprimir Relatório</button>
    </div>

    <!-- Cabeçalho visível apenas na impressão -->
    <div class="print-header print-only">
      <div class="print-header-title">Relatório de Orçamentos</div>
      <div class="print-header-meta">
        <span>
          Período: {{ dataInicial | date:'dd/MM/yyyy' }} a {{ dataFinal | date:'dd/MM/yyyy' }}
        </span>
        <span class="print-header-sep" *ngIf="statusOrcamento"> | Status: {{ statusOrcamento }}</span>
        <span class="print-header-sep"> | Total: {{ orcamentos.length }} registro(s)</span>
        <span class="print-header-sep"> | Gerado em: {{ dataGeracao }}</span>
      </div>
      <div class="print-header-divider"></div>
    </div>

    <div *ngIf="orcamentos.length === 0" class="text-center text-muted py-4">
      Nenhum orçamento encontrado para os filtros selecionados.
    </div>

    <div class="table-responsive" *ngIf="orcamentos.length > 0">
      <table class="table table-striped table-hover print-table">
        <thead class="table-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Cliente</th>
            <th scope="col">Vendedor</th>
            <th scope="col" class="text-center">Status</th>
            <th scope="col" class="text-center">Data Orçamento</th>
            <th scope="col" class="text-center">Validade</th>
            <th scope="col" class="text-end">Subtotal</th>
            <th scope="col" class="text-end">Valor Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let orc of orcamentos">
            <td>{{ orc.id }}</td>
            <td>{{ orc.nomeCliente }}</td>
            <td>{{ orc.nomeVendedor }}</td>
            <td class="text-center">
              <span class="status-badge"
                [class.status-concluido]="orc.statusOrcamento === 'CONCLUIDO'"
                [class.status-aberto]="orc.statusOrcamento === 'ABERTO'"
                [class.status-cancelado]="orc.statusOrcamento === 'CANCELADO'">
                {{ orc.statusOrcamento }}
              </span>
            </td>
            <td class="text-center">{{ orc.dataOrcamento | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ orc.validadeOrcamento | date:'dd/MM/yyyy' }}</td>
            <td class="text-end">{{ orc.subtotal | currency:'BRL' }}</td>
            <td class="text-end fw-bold">{{ orc.valorTotal | currency:'BRL' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="print-totals">
            <td colspan="6" class="text-end fw-bold">Totais:</td>
            <td class="text-end fw-bold">{{ totalSubtotal | currency:'BRL' }}</td>
            <td class="text-end fw-bold">{{ totalValor | currency:'BRL' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>

